import React from "react";
import SuraLogoImage from "../../visuals/SuralinkLogoImages/SuraLogoImage";
import SuralinkLightAndDarkWithText from "../../visuals/SuralinkLogoImages/SuraLogoWithText";

interface SuraLogoProps {
  size: "lg" | "md" | "sm";
  logoHasText: boolean;
  logoColor: "blue" | "white";
  textColor: "dark" | "white";
}

const SuraLogo: React.FC<SuraLogoProps> = ({
  size,
  logoHasText,
  logoColor,
  textColor,
}) => {
  let logo = logoHasText ? (
    <SuralinkLightAndDarkWithText
      size={size}
      logoColor={logoColor}
      textColor={textColor}
    />
  ) : (
    <SuraLogoImage size={size} logoColor={logoColor} />
  );

  return logo;
};

export default SuraLogo;
